import { create as _create } from '@thoughtspot/logger';
const APP_NAME = 'TS-App-sparkflow';
export const create = (moduleName) => _create(`${APP_NAME}-${moduleName}`);
//# sourceMappingURL=index.js.map